import { render } from "./AsideView.vue?vue&type=template&id=01dbaa1b"
import script from "./AsideScript.vue?vue&type=script&lang=js&external"
export * from "./AsideScript.vue?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__